import { render, staticRenderFns } from "./ProdWorkView.vue?vue&type=template&id=7a192ac2&"
import script from "./ProdWorkView.vue?vue&type=script&lang=js&"
export * from "./ProdWorkView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports